import { IContactRepository } from '../../../domain/repositories/contact.repository.interface';
import { ContactRecipient } from '../../../domain/entities/contact-recipient.entity';
import {
  CreateContactRecipientDTO,
  UpdateContactRecipientDTO,
} from '../../dtos/contact/contact-recipient.dto';

export class GetContactRecipientsUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(filters?: { activeOnly?: boolean }): Promise<ContactRecipient[]> {
    return this.repository.getRecipients(filters);
  }
}

export class CreateContactRecipientUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(data: CreateContactRecipientDTO): Promise<ContactRecipient> {
    return this.repository.createRecipient(data);
  }
}

export class UpdateContactRecipientUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string, data: UpdateContactRecipientDTO): Promise<ContactRecipient> {
    return this.repository.updateRecipient(id, data);
  }
}

export class ChangeContactRecipientStatusUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string, isActive: boolean): Promise<ContactRecipient> {
    return this.repository.changeRecipientStatus(id, isActive);
  }
}

export class DeleteContactRecipientUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string): Promise<void> {
    return this.repository.deleteRecipient(id);
  }
}

export class ReorderContactRecipientsUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(items: { id: string; displayOrder: number }[]): Promise<void> {
    return this.repository.reorderRecipients(items);
  }
}
